/* Community Builds for EPP: the public feed + one build (/pages/builds, ?b=<slug>) and the Garage
   "My Builds" tab (start a build, upload photos, publish for +100 points, delete). Same Supabase social layer
   as The Evo Shop (builds are cross-store). Uses the Garage session from rewards.js (window.EPP_SB / "epp:sb");
   signed-out visitors on the feed get a read-only anon client. RLS only returns public builds (or your own).
   Everything members typed is escaped; links and images must be https. Bilingual via T(en, fr). */
(function () {
  "use strict";
  var CFG = window.EPP_REWARDS || {};
  var feedRoot = document.querySelector("[data-epp-builds]");
  var mineRoot = document.querySelector("[data-mybuilds]");
  if ((!feedRoot && !mineRoot) || !CFG.url || !CFG.anonKey) return;

  var LANG = (window.EPP_LOCALE && String(window.EPP_LOCALE).toLowerCase().indexOf("fr") === 0)
    ? "fr" : (localStorage.getItem("epp_lang") || "en");
  function T(en, fr) { return LANG === "fr" ? fr : en; }
  var ROOT = window.EPP_ROOT || "/";
  var STORES = { "the-evo-shop": "https://theevoshop.com", "evolution-plus-performance": "https://evolutionplusperformance.ca" };
  var STORE_SLUG = "evolution-plus-performance";

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  function httpsUrl(u) { return /^https:\/\/[^\s"'<>()]+$/i.test(String(u || "")) ? u : ""; }
  function partUrl(p) {
    var u = String(p.url || "");
    if (/^\/(products|collections)\/[a-z0-9\-\/]+$/i.test(u)) return (STORES[p.store_slug] || "") + u;
    return httpsUrl(u);
  }
  function vehicle(r) { return [r.year, r.make, r.model, r.trim].filter(Boolean).join(" "); }
  function who(o) { return (o && (o.display_name || (o.handle ? "@" + o.handle : ""))) || T("Evolution Plus member", "Membre Evolution Plus"); }
  function initials(o) { var n = who(o).replace(/^@/, "").trim(); return (n.split(/\s+/).map(function (w) { return w[0]; }).join("").slice(0, 2) || "EP").toUpperCase(); }
  function when(d) { try { return new Date(d).toLocaleDateString(LANG === "fr" ? "fr-CA" : "en-CA", { month: "short", year: "numeric" }); } catch (e) { return ""; } }
  function plural(n, en1, enN, fr1, frN) { return n + " " + (n === 1 ? T(en1, fr1) : T(enN, frN)); }
  function link(path) { return (ROOT + path).replace(/\/{2,}/g, "/"); }
  function bg(u) { return "background-image:url('" + esc(u).replace(/'/g, "%27") + "')"; }

  // ---------------- Supabase client: the Garage session if there is one, else anon read-only ----------------
  function hasStoredSession() {
    try { for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf("sb-") === 0 && k.indexOf("-auth-token") > 0 && localStorage.getItem(k)) return true; } } catch (e) {}
    return false;
  }
  var clientP = new Promise(function (resolve) {
    if (window.EPP_SB) return resolve(window.EPP_SB);
    var done = false;
    window.addEventListener("epp:sb", function (e) { if (!done) { done = true; resolve(e.detail); } });
    // rewards.js boots for stored sessions and on the Garage; a signed-out visitor on the feed gets anon reads now
    var wait = (hasStoredSession() || mineRoot) ? 4000 : 0;
    setTimeout(function () {
      if (done) return;
      var go = function () {
        if (done) return; done = true;
        resolve(window.supabase.createClient(CFG.url, CFG.anonKey, { auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false, storageKey: "epp-builds-anon" } }));
      };
      if (window.supabase && window.supabase.createClient) return go();
      var s = document.createElement("script"); s.src = "https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2"; s.onload = go; document.head.appendChild(s);
    }, wait);
  });
  var ctxP = clientP.then(function (sb) {
    return sb.auth.getSession().then(function (r) {
      var user = r && r.data && r.data.session ? r.data.session.user : null;
      if (!user) return { sb: sb, user: null, me: null };
      return sb.from("members").select("id").eq("auth_user_id", user.id).maybeSingle().then(function (m) {
        return { sb: sb, user: user, me: m && m.data ? m.data.id : null };
      });
    });
  });

  // =================================== FEED / ONE BUILD ===================================
  function q(sel) { return feedRoot.querySelector(sel); }
  function card(b, liked) {
    var img = httpsUrl(b.cover_url), v = vehicle(b);
    return '<a class="bcard" href="' + link("pages/builds?b=" + encodeURIComponent(b.slug)) + '">' +
      '<div class="bcard__img' + (img ? ' has-photo" style="' + bg(img) + '"' : '"') + ">" +
        (img ? "" : '<span class="liv"></span><span class="ph">' + esc(v || b.title) + "</span>") +
        (b.make ? '<div class="bcard__tags"><span class="tag tag--red">' + esc(b.make) + "</span></div>" : "") +
        '<span class="bcard__like likebtn"><span class="heart" aria-hidden="true">' + (liked ? "❤" : "♡") + "</span> " + (b.likes_count || 0) + "</span>" +
      "</div>" +
      '<div class="bcard__body">' +
        '<div class="bcard__owner"><span class="avatar avatar--sm">' + esc(initials(b)) + "</span>" + esc(who(b)) + "</div>" +
        '<div class="bcard__title">' + esc(b.title) + "</div>" +
        ((v || b.location) ? '<div class="bcard__spec">' + esc([v, b.location].filter(Boolean).join(" · ")) + "</div>" : "") +
        '<div class="bcard__stats"><span><b>' + (b.likes_count || 0) + "</b> " + T("likes", "j'aime") + "</span><span><b>" + (b.comments_count || 0) + "</b> " + T("comments", "commentaires") + "</span></div>" +
      "</div></a>";
  }
  function renderFeed(ctx) {
    var likesP = ctx.me ? ctx.sb.from("likes").select("build_id").eq("member_id", ctx.me).then(function (r) { return (r.data || []).map(function (x) { return x.build_id; }); }) : Promise.resolve([]);
    Promise.all([ctx.sb.from("build_feed").select("*").order("created_at", { ascending: false }).limit(120), likesP]).then(function (r) {
      var list = (r[0] && r[0].data) || [], liked = r[1] || [];
      q("[data-bl-loading]").hidden = true;
      q("[data-bl-empty]").hidden = list.length > 0;
      var grid = q("[data-bl-grid]");
      function paint(make) {
        grid.innerHTML = list.filter(function (b) { return !make || b.make === make; }).map(function (b) { return card(b, liked.indexOf(b.id) > -1); }).join("");
      }
      paint("");
      var makes = list.map(function (b) { return b.make; }).filter(function (m, i, a) { return m && a.indexOf(m) === i; }).sort();
      if (makes.length > 1) {
        var f = q("[data-bl-filters]"); f.hidden = false;
        f.innerHTML = '<button type="button" class="filter-chip is-active" data-make="">' + T("All", "Tout") + "</button>" +
          makes.map(function (m) { return '<button type="button" class="filter-chip" data-make="' + esc(m) + '">' + esc(m) + "</button>"; }).join("");
        f.addEventListener("click", function (e) {
          var c = e.target.closest(".filter-chip"); if (!c) return;
          f.querySelectorAll(".filter-chip").forEach(function (x) { x.classList.toggle("is-active", x === c); });
          paint(c.getAttribute("data-make"));
        });
      }
    }).catch(function () { q("[data-bl-loading]").textContent = T("The feed couldn't load right now. Refresh to try again.", "Le fil n'a pas pu se charger. Rafraîchis la page pour réessayer."); });
  }

  function renderDetail(ctx, slug) {
    q("[data-bl-feed]").hidden = true;
    var sb = ctx.sb;
    sb.from("builds").select("*").eq("slug", slug).maybeSingle().then(function (r) {
      var b = r.data;
      if (!b || b.status !== "public") { q("[data-bl-missing]").hidden = false; return; }
      return Promise.all([
        sb.from("build_photos").select("*").eq("build_id", b.id).order("sort"),
        sb.from("build_parts").select("*").eq("build_id", b.id).order("sort"),
        sb.from("comments").select("*").eq("build_id", b.id).order("created_at"),
        sb.from("member_social").select("*").eq("member_id", b.member_id).maybeSingle(),
        sb.from("build_stats").select("*").eq("build_id", b.id).maybeSingle(),
        sb.from("build_feed").select("make,model,year").eq("id", b.id).maybeSingle()
      ]).then(function (x) {
        b.photos = x[0].data || []; b.parts = x[1].data || []; b.comments = x[2].data || [];
        var o = x[3].data || {}, stats = x[4].data || {}, veh = x[5].data || {};
        q("[data-bl-detail]").hidden = false;
        document.title = b.title + " | " + T("Community Builds", "Projets de la communauté") + " | Evolution Plus Performance";
        q("[data-bl-h1]").textContent = b.title;
        q("[data-bl-intro]").textContent = vehicle(veh) ? who(o) + T("'s ", " · ") + vehicle(veh) : T("A build from the Evolution Plus community.", "Un projet de la communauté Evolution Plus.");
        q("[data-bd-crumbsep]").hidden = false; q("[data-bd-crumb]").textContent = b.title;
        q("[data-bl-post]").hidden = true;

        var av = q("[data-bd-avatar]"), avu = httpsUrl(o.avatar_url);
        if (avu) { av.setAttribute("style", bg(avu) + ";background-size:cover"); av.textContent = ""; } else av.textContent = initials(o);
        q("[data-bd-owner]").textContent = who(o);
        q("[data-bd-sub]").textContent = [o.handle && o.display_name ? "@" + o.handle : "", b.location || o.location || "", plural(o.builds_count || 1, "build", "builds", "projet", "projets")].filter(Boolean).join(" · ");
        q("[data-bd-followers]").innerHTML = "<b>" + (o.followers || 0) + "</b> " + esc((o.followers || 0) === 1 ? T("follower", "abonné") : T("followers", "abonnés"));

        var tags = [];
        if (vehicle(veh)) tags.push('<span class="tag tag--red">' + esc(vehicle(veh)) + "</span>");
        if (b.location) tags.push('<span class="tag">' + esc(b.location) + "</span>");
        q("[data-bd-tags]").innerHTML = tags.join("");

        var pics = b.photos.map(function (p) { return httpsUrl(p.url); }).filter(Boolean);
        if (httpsUrl(b.cover_url) && pics.indexOf(b.cover_url) < 0) pics.unshift(b.cover_url);
        var main = q("[data-bd-main]"), thumbs = q("[data-bd-thumbs]");
        function show(i) { main.setAttribute("style", bg(pics[i])); main.innerHTML = ""; thumbs.querySelectorAll(".gallery__thumb").forEach(function (t, k) { t.classList.toggle("is-active", k === i); }); }
        if (pics.length) {
          thumbs.innerHTML = pics.length > 1 ? pics.map(function (u, i) { return '<button type="button" class="gallery__thumb" data-i="' + i + '" style="' + bg(u) + '" aria-label="Photo ' + (i + 1) + '"></button>'; }).join("") : "";
          show(0);
          thumbs.addEventListener("click", function (e) { var t = e.target.closest(".gallery__thumb"); if (t) show(+t.getAttribute("data-i")); });
        }
        q("[data-bd-summary]").textContent = b.summary || T("The owner hasn't written the story yet.", "Le propriétaire n'a pas encore écrit l'histoire.");
        q("[data-bd-date]").textContent = T("Posted ", "Publié ") + when(b.created_at);

        var parts = b.parts.filter(function (p) { return p.title; });
        if (parts.length) {
          q("[data-bd-parts-wrap]").hidden = false;
          q("[data-bd-parts]").innerHTML = parts.map(function (p) {
            var u = partUrl(p), img = httpsUrl(p.image_url);
            var inner = '<div class="img"' + (img ? ' style="' + bg(img) + '"' : "") + "></div><div><div class=\"pn\">" + esc(p.title) + "</div>" + (p.price_text ? '<div class="pr">' + esc(p.price_text) + "</div>" : "") + "</div>";
            var own = u && u.indexOf(location.origin) === 0;
            return u ? '<a class="sbb-part" href="' + esc(u) + '"' + (own ? "" : ' target="_blank" rel="noopener"') + ">" + inner + "</a>" : '<div class="sbb-part">' + inner + "</div>";
          }).join("");
        }
        wireSocial(ctx, b, stats.likes_count || 0);
      });
    }).catch(function () { q("[data-bl-missing]").hidden = false; });
  }

  function renderComments(ctx, b) {
    var list = b.comments || [];
    q("[data-bd-ccount]").textContent = plural(list.length, "comment", "comments", "commentaire", "commentaires");
    var box = q("[data-bd-comments]");
    if (!list.length) { box.innerHTML = '<p class="bl-none">' + T("No comments yet.", "Aucun commentaire pour l'instant.") + "</p>"; return; }
    var ids = list.map(function (c) { return c.member_id; }).filter(function (v, i, a) { return a.indexOf(v) === i; }).slice(0, 60);
    ctx.sb.from("member_social").select("member_id,handle,display_name").in("member_id", ids).then(function (r) {
      var by = {}; (r.data || []).forEach(function (p) { by[p.member_id] = p; });
      box.innerHTML = list.map(function (c) {
        return '<div class="bl-comment"><div class="who">' + esc(who(by[c.member_id])) + "<span>" + esc(when(c.created_at)) + '</span></div><div class="body">' + esc(c.body) + "</div></div>";
      }).join("");
    });
  }

  function wireSocial(ctx, b, likes) {
    var sb = ctx.sb, likeBtn = q("[data-bd-like]"), liked = false;
    function paintLike() { likeBtn.setAttribute("aria-pressed", liked ? "true" : "false"); q("[data-bd-likes]").textContent = likes; }
    paintLike();
    renderComments(ctx, b);
    q("[data-bd-signin]").hidden = !!ctx.me;
    q("[data-bd-cform]").hidden = !ctx.me;
    if (!ctx.me) { likeBtn.addEventListener("click", function () { location.href = link("pages/garage"); }); return; }

    sb.from("likes").select("build_id").eq("member_id", ctx.me).eq("build_id", b.id).maybeSingle().then(function (r) { liked = !!r.data; paintLike(); });
    likeBtn.addEventListener("click", function () {
      likeBtn.disabled = true;
      var op = liked ? sb.from("likes").delete().eq("member_id", ctx.me).eq("build_id", b.id) : sb.from("likes").insert({ member_id: ctx.me, build_id: b.id });
      op.then(function (r) { if (!r.error) { liked = !liked; likes += liked ? 1 : -1; paintLike(); } likeBtn.disabled = false; });
    });

    var fb = q("[data-bd-follow]");
    if (ctx.me !== b.member_id) {
      var following = false;
      var paintF = function () { fb.textContent = following ? T("Following", "Abonné") : T("Follow", "Suivre"); };
      sb.from("follows").select("follower_id").eq("follower_id", ctx.me).eq("following_id", b.member_id).maybeSingle().then(function (r) { following = !!r.data; fb.hidden = false; paintF(); });
      fb.addEventListener("click", function () {
        fb.disabled = true;
        var op = following ? sb.from("follows").delete().eq("follower_id", ctx.me).eq("following_id", b.member_id) : sb.from("follows").insert({ follower_id: ctx.me, following_id: b.member_id });
        op.then(function (r) { if (!r.error) following = !following; paintF(); fb.disabled = false; });
      });
    }

    var form = q("[data-bd-cform]"), msg = q("[data-bd-cmsg]");
    form.body.placeholder = T("Say something about this build", "Dis quelque chose sur ce projet");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var body = form.body.value.trim(); if (!body) return;
      var btn = form.querySelector("button"); btn.disabled = true; msg.textContent = ""; msg.className = "bl-msg";
      sb.from("comments").insert({ build_id: b.id, member_id: ctx.me, body: body }).select().single().then(function (r) {
        btn.disabled = false;
        if (r.error) { msg.textContent = T("Couldn't post that. Try again.", "Impossible de publier. Réessaie."); msg.className = "bl-msg err"; return; }
        b.comments = (b.comments || []).concat([r.data]); form.body.value = ""; renderComments(ctx, b);
      });
    });
  }

  // =================================== GARAGE: MY BUILDS ===================================
  var mineStarted = false;   // wire the panel once, whichever path signs the member in first
  function initMine(ctx) {
    if (!ctx.me || mineStarted) return;
    mineStarted = true;
    var panel = mineRoot.closest("[data-panel]") || document;
    var form = panel.querySelector("[data-build-form]"), msg = panel.querySelector("[data-bf-msg]");
    var empty = panel.querySelector("[data-mybuilds-empty]");
    var sb = ctx.sb;

    function setMsg(t, err) { msg.textContent = t; msg.className = "bf-msg" + (err ? " err" : ""); }
    function load() {
      return Promise.all([
        sb.from("builds").select("*").eq("member_id", ctx.me).order("created_at", { ascending: false }),
        sb.from("vehicles").select("*").eq("member_id", ctx.me).order("created_at", { ascending: false })
      ]).then(function (r) { paintMine(r[0].data || []); paintVehicles(r[1].data || []); });
    }
    function paintVehicles(vs) {
      var sel = form.querySelector("[data-bf-vehicle]"); if (!sel) return;
      sel.innerHTML = '<option value="">' + T("Pick from your Garage", "Choisis dans ton garage") + "</option>" +
        vs.map(function (v) { return '<option value="' + esc(v.id) + '"' + (v.is_active ? " selected" : "") + ">" + esc(vehicle(v) || v.nickname || "") + "</option>"; }).join("");
    }
    function paintMine(list) {
      empty.hidden = list.length > 0;
      mineRoot.innerHTML = list.map(function (b) {
        var img = httpsUrl(b.cover_url), pub = b.status === "public";
        return '<div class="bcard"><div class="bcard__img' + (img ? ' has-photo" style="' + bg(img) + ';background-size:cover;background-position:center"' : '"') + ">" +
          (img ? "" : '<span class="liv"></span><span class="ph">' + esc(b.title) + "</span>") +
          '<span class="mb-status ' + (pub ? "public" : "") + '">' + (pub ? T("Public", "Public") : T("Draft", "Brouillon")) + "</span></div>" +
          '<div class="bcard__body"><div class="bcard__title">' + esc(b.title) + "</div>" +
          '<div class="mb-acts">' +
            (pub ? '<a class="btn btn-red btn-sm" href="' + link("pages/builds?b=" + encodeURIComponent(b.slug)) + '">' + T("View", "Voir") + "</a>"
                 : '<button type="button" class="btn btn-red btn-sm" data-mb-pub="' + esc(b.id) + '">' + T("Publish (+100 pts)", "Publier (+100 pts)") + "</button>") +
            '<button type="button" class="btn btn-sm mb-del" data-mb-del="' + esc(b.id) + '">' + T("Delete", "Supprimer") + "</button>" +
          "</div></div></div>";
      }).join("");
    }
    mineRoot.addEventListener("click", function (e) {
      var p = e.target.closest("[data-mb-pub]"), d = e.target.closest("[data-mb-del]");
      if (p) { p.disabled = true; sb.from("builds").update({ status: "public" }).eq("id", p.getAttribute("data-mb-pub")).then(load); }
      if (d && window.confirm(T("Delete this build and its photos? This can't be undone.", "Supprimer ce projet et ses photos? C'est irréversible."))) {
        d.disabled = true; sb.from("builds").delete().eq("id", d.getAttribute("data-mb-del")).then(load);
      }
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector("[data-bf-save]");
      var files = Array.prototype.slice.call(form.photos.files || []).filter(function (f) { return /^image\/(jpeg|png|webp)$/.test(f.type) && f.size <= 10 * 1024 * 1024; }).slice(0, 8);
      if (form.photos.files && form.photos.files.length > files.length) setMsg(T("Some photos were skipped (JPG, PNG or WebP up to 10 MB, 8 max).", "Certaines photos ont été ignorées (JPG, PNG ou WebP jusqu'à 10 Mo, 8 max)."), true);
      btn.disabled = true;
      sb.from("builds").insert({ member_id: ctx.me, title: form.title.value.trim(), summary: form.summary.value.trim() || null, location: form.location.value.trim() || null, vehicle_id: form.vehicle_id.value || null, status: "draft" })
        .select().single().then(function (r) {
          if (r.error) throw r.error;
          var b = r.data, i = 0, cover = null;
          var next = function () {
            if (i >= files.length) return Promise.resolve();
            var f = files[i], n = i++;
            setMsg(T("Uploading photo ", "Téléversement de la photo ") + (n + 1) + "/" + files.length + "…");
            var path = ctx.user.id + "/" + b.id + "/" + Date.now() + "-" + n + "." + (f.type.split("/")[1] === "jpeg" ? "jpg" : f.type.split("/")[1]);
            return sb.storage.from("builds").upload(path, f, { contentType: f.type, upsert: false }).then(function (up) {
              if (up.error) return next();
              var url = sb.storage.from("builds").getPublicUrl(path).data.publicUrl;
              if (!cover) cover = url;
              return sb.from("build_photos").insert({ build_id: b.id, url: url, sort: n }).then(next);
            });
          };
          return next().then(function () { return cover ? sb.from("builds").update({ cover_url: cover }).eq("id", b.id) : null; });
        }).then(function () {
          form.reset(); setMsg(T("Saved as a draft. Publish it when you're ready.", "Enregistré en brouillon. Publie-le quand tu es prêt."));
          return load();
        }).catch(function () { setMsg(T("Couldn't save the build. Try again.", "Impossible d'enregistrer le projet. Réessaie."), true); })
        .then(function () { btn.disabled = false; });
    });
    load();
  }

  // =================================== boot ===================================
  ctxP.then(function (ctx) {
    if (feedRoot) { var slug = (new URLSearchParams(location.search).get("b") || "").trim(); if (slug) renderDetail(ctx, slug); else renderFeed(ctx); }
    if (mineRoot) initMine(ctx);
  });
  // the Garage signs people in on this page: pick up "My Builds" once a session appears
  if (mineRoot) clientP.then(function (sb) {
    sb.auth.onAuthStateChange(function (evt, session) {
      if (evt !== "SIGNED_IN" || !session || mineStarted) return;
      sb.from("members").select("id").eq("auth_user_id", session.user.id).maybeSingle().then(function (m) {
        if (m.data) initMine({ sb: sb, user: session.user, me: m.data.id });
      });
    });
  });
})();
